import { useState, useEffect } from "react";
import axios from "axios";
import { useClient } from "ClientContext";


//useDailyRate 
interface DailyRate {
    date: string;
    price: number;
}
interface DailyRatesResponse {
    item: DailyRate[];
    [key: string]: any;
}
// useDailyRates

const SERVER_URL = process.env.REACT_APP_SERVER_URL || "";

interface UseDailyRatesParams {
    listingId: string;
    roomId: string;
}

const useDailyRates = ({ listingId, roomId }: UseDailyRatesParams) => {
    const { internal_ID, actions } = useClient();
    const [ratesCalendar, setRatesCalender] = useState<DailyRatesResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {

        setLoading(true);
        setError(null);

        const fetchData = async () => {
            try {
                const fromDate = new Date();
                const toDate = new Date();
                toDate.setMonth(toDate.getMonth() + 12); // 12 months ahead

                if(!internal_ID || !listingId || !roomId) {
                    return;
                }

                const response = await axios.post(`${SERVER_URL}/api/controller`, {
                    action: actions.fetchRateCalendar,
                    internal_ID,
                    default_Lang: "en",
                    params: {
                        listingId: listingId,
                        roomId: roomId,
                        availabilities: {
                            fromDate: fromDate,
                            toDate: toDate,

                        }
                    },

                });
                setRatesCalender(response.data.item);
                setLoading(false);
            } catch (err: any) {
                console.error("Error fetching daily rates:", err);
                setError(err.message || "Error fetching daily rates");
                setLoading(false);
            }

        };

        fetchData();

    }, [internal_ID,listingId,roomId]);

    const ratesLoading = loading;
    const ratesError = error;

    return { ratesCalendar, ratesLoading, ratesError };
};


export default useDailyRates;